export default "__VITE_ASSET__da110181__"